module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.a7bb2060.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraBoldItalic.woff
// module id = 685
// module chunks = 21